import * as C from "react";
import { forwardRef as o } from "react";
const n = o(function(e, t) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ C.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.18921 3L3.00001 7.16505L8.17465 11.3476L8.17931 8.68042C8.36322 8.67533 8.54785 8.67174 8.73441 8.67191C11.4994 8.66831 13.9913 9.2567 15.6676 10.1171C16.507 10.5433 17.1341 11.0339 17.5105 11.4911C17.8902 11.9558 18.0239 12.343 18.0266 12.7179C18.0252 12.98 17.9605 13.2353 17.7979 13.5301C17.5573 13.9685 17.0667 14.4783 16.3227 14.9471C15.7683 15.2986 15.0804 15.6253 14.2903 15.8994L16.8644 17.9799C17.6309 17.6049 18.3216 17.169 18.9205 16.6693C19.5263 16.1605 20.0389 15.5808 20.4103 14.9163C20.7807 14.2544 21.0011 13.4997 21 12.7179V12.7082C21 11.5693 20.5309 10.5138 19.8215 9.66582C18.7464 8.38268 17.1549 7.45262 15.2556 6.79215C13.3537 6.13799 11.1248 5.77193 8.73441 5.7708C8.54964 5.77097 8.36731 5.7765 8.1844 5.78088L8.18921 3ZM13.9479 18.4692L12.5404 17.3316V17.3117C12.5337 17.313 12.5269 17.3139 12.5201 17.3152L10.8004 15.9252L10.7976 17.4941C10.686 17.4972 10.574 17.4994 10.4608 17.4993V17.4857C8.77872 17.4883 7.26315 17.1302 6.2433 16.6068C6.15633 16.5626 6.07847 16.5161 5.9991 16.4701C5.9882 16.464 5.97759 16.4578 5.96669 16.4519C5.92188 16.4253 5.87742 16.3991 5.83512 16.372C4.78337 15.7502 4.13493 14.9184 4.13493 14.0011C4.13493 13.1739 4.66062 12.4152 5.53485 11.8178C4.95502 12.0994 4.44323 12.4356 4.02487 12.8372C3.42203 13.4133 2.99879 14.1721 3.00001 15.0249C2.99843 15.7199 3.28401 16.3641 3.71656 16.8814C4.37046 17.6618 5.33875 18.2279 6.49375 18.6294C6.50127 18.6319 6.50974 18.6337 6.51719 18.6362L6.49375 18.643C7.65089 19.041 9.00686 19.2635 10.4608 19.2642C10.5728 19.2642 10.6839 19.2624 10.7945 19.2597L10.7914 21L13.9479 18.4692Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as MyBets
};
